import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/admin/DealerCardLinks";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/dealer-card-links/")({
  head: () => routeHead("/admin/dealer-card-links/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
